// frontend/src/components/auth/register/ProjectInfoStep.tsx

import React from "react";
import { TextField, Typography } from "@mui/material";
import { FormikProps } from "formik";
import PhoneInput from "../../common/PhoneInput";
import { VERDE_MENTA } from "../../../themes/themeConstants";
import { registerFieldSx } from "./registerStyles";
import type { RegisterFormValues } from "../../../hooks/auth/useRegisterForm";

interface ProjectInfoStepProps {
  formik: FormikProps<RegisterFormValues>;
  t: {
    projectName: string;
    phone: string;
    website: string;
  };
}

const ProjectInfoStep: React.FC<ProjectInfoStepProps> = ({ formik, t }) => {
  return (
    <>
      <Typography
        variant="body2"
        sx={{ color: VERDE_MENTA, fontWeight: 500, mb: 0.5 }}
      >
        Nome do Projeto
      </Typography>
      <TextField
        fullWidth
        margin="none"
        id="projectName"
        name="projectName"
        placeholder={t.projectName}
        value={formik.values.projectName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.projectName && Boolean(formik.errors.projectName)}
        helperText={formik.touched.projectName && formik.errors.projectName}
        sx={{ mb: 1.5, ...registerFieldSx }}
        InputProps={{ sx: { py: 1 } }}
      />

      <Typography
        variant="body2"
        sx={{ color: VERDE_MENTA, fontWeight: 500, mb: 0.5, mt: 1.5 }}
      >
        Telefone
      </Typography>
      <PhoneInput
        fullWidth
        margin="none"
        id="phone"
        name="phone"
        placeholder={t.phone}
        value={formik.values.phone}
        onChange={(value: string) => formik.setFieldValue("phone", value)}
        onBlur={() => formik.setFieldTouched("phone", true)}
        error={formik.touched.phone && Boolean(formik.errors.phone)}
        helperText={formik.touched.phone && formik.errors.phone}
        sx={{ mb: 1.5, ...registerFieldSx }}
        InputProps={{ sx: { py: 1 } }}
      />

      <Typography
        variant="body2"
        sx={{ color: VERDE_MENTA, fontWeight: 500, mb: 0.5, mt: 1.5 }}
      >
        Website (opcional)
      </Typography>
      <TextField
        fullWidth
        margin="none"
        id="website"
        name="website"
        placeholder={t.website}
        value={formik.values.website}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.website && Boolean(formik.errors.website)}
        helperText={formik.touched.website && formik.errors.website}
        sx={{ mb: 1.5, ...registerFieldSx }}
        InputProps={{ sx: { py: 1 } }}
      />
    </>
  );
};

export default ProjectInfoStep;
